export const defaultFilters = {
  sales: {
    metric: 'hosting'
  },
  evaluations: {
    metric: 'hosting'
  }
};